<script setup>
import { computed } from 'vue';

defineProps({
  width: {
    type: Number,
    default: 82,
    validator: value => value > 0,
  },
  height: {
    type: Number,
    default: 82,
    validator: value => value > 0,
  },
});

const uniqueId = `clind_${Math.random().toString(36).slice(2, 11)}`;
const filterId = computed(() => `filter0_dd_${uniqueId}`);
const gradientId = computed(() => `paint0_linear_${uniqueId}`);
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <g :filter="`url(#${filterId})`">
      <path
        d="M5 37C5 17.1178 21.1178 1 41 1C60.8823 1 77 17.1178 77 37C77 56.8823 60.8823 73 41 73C21.1178 73 5 56.8823 5 37Z"
        :fill="`url(#${gradientId})`"
      />
      <rect x="27" y="20" width="4.66667" height="4.66667" fill="#010101" />
      <rect
        x="27"
        y="35.1667"
        width="4.66667"
        height="8.16667"
        fill="#010101"
      />
      <rect
        x="27.4913"
        y="46.0667"
        width="4.91228"
        height="8.84211"
        transform="rotate(-44.9461 27.4913 46.0667)"
        fill="#010101"
      />
      <rect
        width="4.91228"
        height="8.84211"
        transform="matrix(-0.707771 -0.706442 -0.706441 0.707771 53.9162 46.0667)"
        fill="#010101"
      />
      <rect
        x="36.3333"
        y="53.8333"
        width="5.83333"
        height="9.33333"
        transform="rotate(-90 36.3333 53.8333)"
        fill="#010101"
      />
      <rect
        x="50.3333"
        y="35.1667"
        width="4.66667"
        height="8.16667"
        fill="#010101"
      />
      <rect
        x="50.3333"
        y="20"
        width="4.66667"
        height="4.66667"
        fill="#010101"
      />
      <path
        d="M31.5 35.5V43.5L36.5 48.5H45L50.5 43V35.5"
        stroke="#010101"
        fill="none"
        stroke-width="1"
      />
    </g>
    <defs>
      <filter
        :id="filterId"
        x="0"
        y="0"
        width="82"
        height="82"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          :result="`effect1_dropShadow_${uniqueId}`"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          :result="`effect1_dropShadow_${uniqueId}`"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          :result="`effect2_dropShadow_${uniqueId}`"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          :in2="`effect1_dropShadow_${uniqueId}`"
          :result="`effect2_dropShadow_${uniqueId}`"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          :in2="`effect2_dropShadow_${uniqueId}`"
          result="shape"
        />
      </filter>
      <linearGradient
        :id="gradientId"
        x1="8.9375"
        y1="1"
        x2="77"
        y2="88.1875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8FFEC" />
        <stop offset="1" stop-color="#E1E88D" />
      </linearGradient>
    </defs>
  </svg>
</template>
